<template>
  <div id="CRUD_DETAIL">
    <v-container grid-list-xl fluid>
      <!-- api 호출등 화면의 락을 건다.-->
      <v-overlay :value="loading" :absolute="true">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar flat>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider class="mt-0"></v-divider>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="(item, index) in objInfo.fields"
                    v-bind:key="index"
                    :class="item.class"
                    pa-1
                  >
                    <template v-if="item.hideDetail"> </template>
                    <template v-else>
                      {{ item.hideDetail }}
                      <!-- view mode or readonly-->
                      <template
                        v-if="$route.meta.detail == 'view' || item.readonly"
                      >
                        <!-- type textarea -->
                        <v-textarea
                          v-if="item.type == 'textarea' || item.type == 'json'"
                          v-model="editedItem[item.key]"
                          :label="item.text ? item.text : item.key"
                          readonly
                        ></v-textarea>
                        <SelectForm
                          dense
                          v-else-if="item.type == 'select'"
                          v-model="editedItem[item.key]"
                          :itemInfo="item"
                          :isEditing="false"
                        ></SelectForm>
                        <v-img
                          dense
                          v-else-if="item.type == 'image'"
                          :lazy-src="editedItem[item.key]"

                          :src="editedItem[item.key]"
                        ></v-img>
                        <v-text-field
                          v-else
                          v-model="editedItem[item.key]"
                          :label="item.text ? item.text : item.key"
                          readonly
                          class="readonly"
                        ></v-text-field>
                      </template>
                      <template v-else>
                        <v-textarea
                          v-if="item.type == 'textarea' || item.type == 'json'"
                          v-model="editedItem[item.key]"
                          :label="item.text ? item.text : item.key"
                          :readlony="false"
                        ></v-textarea>
                        <v-img
                          dense
                          v-else-if="item.type == 'image'"
                          :lazy-src="editedItem[item.key]"

                          :src="editedItem[item.key]"
                        ></v-img>
                        <SelectForm
                          dense
                          v-else-if="item.type == 'select'"
                          v-model="editedItem[item.key]"
                          :itemInfo="item"
                          :isEditing="true"
                        ></SelectForm>
                        <SelectForm
                          dense
                          v-else-if="item.type == 'role'"
                          v-model="editedItem[item.key]"
                          :itemList="roleList"
                          :itemInfo="item"
                          :isEditing="true"
                        ></SelectForm>
                        <v-text-field
                          v-else
                          v-model="editedItem[item.key]"
                          :label="item.text ? item.text : item.key"
                          :readlony="false"
                        ></v-text-field>
                      </template>
                    </template>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions v-if="$route.meta.detail == 'edit'">
              <v-spacer></v-spacer>
              <v-btn @click="close">Go Back</v-btn>
              <v-btn v-if="!(objInfo.deny && objInfo.deny.edit)" @click="close"
                >Cancel</v-btn
              >
              <v-btn v-if="!(objInfo.deny && objInfo.deny.edit)" @click="save"
                >Save</v-btn
              >
            </v-card-actions>
            <v-card-actions v-if="$route.meta.detail == 'new'">
              <v-spacer></v-spacer>
              <v-btn @click="close">Go Back</v-btn>
              <v-btn v-if="!(objInfo.deny && objInfo.deny.new)" @click="close"
                >Cancel</v-btn
              >
              <v-btn v-if="!(objInfo.deny && objInfo.deny.new)" @click="save"
                >Save</v-btn
              >
            </v-card-actions>
            <v-card-actions v-if="$route.meta.detail == 'view'">
              <v-spacer></v-spacer>
              <v-btn @click="close">Go Back</v-btn>
              <v-btn v-if="!(objInfo.deny && objInfo.deny.edit)" @click="edit"
                >Edit</v-btn
              >
              <v-btn
                v-if="!(objInfo.deny && objInfo.deny.delete)"
                @click="remove"
                >Delete</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { AdminAPI } from "@/api";
import crud_util from "./crud_util";
import status from "../../constants/status";
import _ from "lodash";
import * as moment from "moment/moment";

import SelectForm from "@/components/common/SelectForm";
export default {
  components: { SelectForm },
  data: () => {
    return {
      title: "Detail",
      loading: false,
      loadingMsg: "Processing",
      headers: [],
      editedItem: {},
    };
  },
  filters: {
    dataFilter: crud_util.dataFilter,
  },
  computed: {
    roleList() {
      console.log(status.ROLE);

      const keys = Object.keys(status.ROLE);
      let ret = [];
      for (let i = 0; i < keys.length; i++) {
        ret.push(status.ROLE[keys[i]]);
      }
      return ret;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    objInfo() {
      return this.$store.state.admin.objInfo;
    },
  },

  watch: {},
  beforeCreate: () => {},

  async created() {
    this.loading = true;
    this.objNm = this.$route.params.objNm;
    this.uid = this.$route.params.uid;

    if (this.$route.meta.detail == "new") {
      await this.$store.dispatch("admin/newObj", this.objNm);
    } else {
      await this.$store.dispatch("admin/getObj", {
        objNm: this.objNm,
        uid: this.uid,
      });
    }
    this.initialize();
  },

  methods: {
    /**
     * new ,edit form...
     */
    makeInput() {
      let info = this.$store.state.admin.objInfo;
      this.editedItem = {};
      let detailObj = this.$store.state.admin.detail;

      _.each(info.fields, (item) => {
        if (this.$route.meta.detail == "new") {
          this.editedItem[item.key] = undefined;
        } else {
          if (item.type === "DateTime" || item.type === "timestamp") {
            let value = detailObj.data[item.key];
            if (value) {
              if (value._seconds)
                // for firebase data type
                this.editedItem[item.key] = moment(
                  value._seconds * 1000
                ).format("YYYY-MM-DD HH:mm:ss");
              else
                this.editedItem[item.key] = moment(value).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
            }
          } else if (item.type === "select") {
            this.editedItem[item.select.text] =
              detailObj.data[item.select.text];
            this.editedItem[item.key] = detailObj.data[item.key];
          } else {
            this.editedItem[item.key] = detailObj.data[item.key];
          }
        }
      });
    },

    initialize() {
      this.makeInput();
      this.loading = false;
    },
    remove() {},
    edit() {
      // loader.hide();
      this.$router.push({
        name: "editObj",
        params: this.$route.params,
      });
    },
    close() {
      this.$router.go(-1);
    },

    async save() {
      this.loading = true;
      let sendObj = {
        obj: this.editedItem,
        objNm: this.objNm,
        uid: this.uid,
      };
      try {
        if (this.$route.meta.detail == "new") {
          let r = await AdminAPI.create(sendObj);
        } else {
          let r = await AdminAPI.update(sendObj);
          console.log("update", r);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/crud/Detail.vue